<script setup>
import { ref } from 'vue'
import EmailAccess from './EmailAccess.vue';

const paywallEmailAccessRef = ref(null)
const props = defineProps({
  currentPaywall: {
    type: Function,
  }
})

// Adding new email-access grants is retired; this wrapper only renders the
// read-only management list now. Kept for callers that may still refresh it.
const updateEmailAccess = () => {
  paywallEmailAccessRef.value.setupUsers()
}
defineExpose({ updateEmailAccess })
</script>

<template>
  <email-access :paywallStreamId="props.currentPaywall.id" :key="props.currentPaywall.id" ref="paywallEmailAccessRef" />
</template>

<style scoped></style>
